import _get from 'lodash/get';
import {IWHIJoinState} from '../../store';
import * as aboutYouDetailsSelectors from './aboutYouDetails';
import * as personalDetailsSelectors from './personalDetails';
import * as funnelProgressSelectors from './funnelProgress';
import * as paymentDetailsSelectors from './paymentDetails';
import * as contactDetailsSelectors from './contactDetails';
import * as visaDetailsSelectors from './visaDetails';
import * as healthDetailsSelectors from './healthDetails';
import type {IWHISession} from '@nib/types-session-api';
import {PricingState} from '../../pricing/types';

export const getSessionState = (state: IWHIJoinState): IWHISession => _get(state, 'session.session', {} as IWHISession);
export const getPricingState = (state: IWHIJoinState): PricingState => state.pricing;
export const getFetchedSession = (state: IWHIJoinState) => state.session.fetchedSession;
export const getFundId = (state: IWHIJoinState) => getSessionState(state).fundId;

export const getIsLoadingSession = (state: IWHIJoinState) => state.session.loadingSession;

export const getPersonalDetails = (state: IWHIJoinState) => personalDetailsSelectors.selectData(state);
export const getAboutYouDetails = (state: IWHIJoinState) => aboutYouDetailsSelectors.selectData(state);
export const getFunnelProgress = (state: IWHIJoinState) => funnelProgressSelectors.selectData(state);
export const getFurthestPage = (state: IWHIJoinState) => funnelProgressSelectors.selectLastCompletedPageStepOrder(state);
export const getPaymentDetails = (state: IWHIJoinState) => paymentDetailsSelectors.selectData(state);
export const getContactDetails = (state: IWHIJoinState) => contactDetailsSelectors.selectData(state);

export const getVisaDetails = (state: IWHIJoinState) => visaDetailsSelectors.selectData(state);

export const getGovernmentDetails = (state: IWHIJoinState) => healthDetailsSelectors.selectGovernmentData(state);
export const getSessionId = (state: IWHIJoinState) => getSessionState(state).id;
